import { SimplePaymentData } from "../../types/TransactionSummary";
import { AmountIcon, EyeIcon, FeesIcon, UserIcon } from "../Icons";

export default function PaymentService({
  simplePaymentData,
}: {
  simplePaymentData: SimplePaymentData;
}) {
  return (
    <div className="flex justify-between items-start py-4">
      <div className="flex">
        <div className="w-[200px]">
          <h3 className="text-lg font-semibold text-custom-dark-blue-new">
            Payment
          </h3>
          <p className="text-sm text-gray-500">Taram</p>
        </div>

        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
              <UserIcon className="size-4" />{" "}
              <span className="text-gray-500">From/To:</span>{" "}
              <span className="font-medium">
                {simplePaymentData?.beneficiary_details?.contact_person_name}
              </span>
            </p>

            <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
              <AmountIcon className="size-4" />{" "}
              <span className="text-gray-500">Amount:</span> $
              {simplePaymentData.amount_sent}
            </p>

            <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
              <FeesIcon className="size-4" />{" "}
              <span className="text-gray-500">Fee:</span> $
              {simplePaymentData.fees}
            </p>
          </div>

          <div className="space-x-3">
            <button className="bg-red-100 text-red-500 text-sm px-3 py-1 border border-red-500 rounded-xl">
              Deny
            </button>
            <button className="bg-green-100 text-green-500 text-sm px-3 py-1 border border-green-500 rounded-xl">
              Approve
            </button>
          </div>
        </div>
      </div>

      <div className="w-[264px] flex items-center gap-3">
        <button className="flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg">
          <EyeIcon className="size-5" /> View Detail
        </button>
        <span
          className={`text-sm font-medium px-3 py-1 rounded-xl ${
            status === "Approved"
              ? "bg-green-50 text-green-500 border border-green-400"
              : "bg-gray-50 text-gray-500 border border-gray-400"
          }`}
        >
          ↑ {simplePaymentData.status || "Processing"}
        </span>
      </div>
    </div>
  );
}
